import React, { useState } from 'react';
import MathJax from "react-mathjax4";
import { useStyles, useTranslations } from "examsbook-react-sdk/custom-hooks";
import { useSelector, useDispatch } from "react-redux";
import useUserLanguage from "examsbook-react-sdk/custom-hooks/useUserLanguage";
import { saveQuestion } from "examsbook-react-sdk/actions";
import { toggleMarkForReview } from "examsbook-react-sdk/actions";

/**
 * Question title.
 * @param props
  @returns {}
 * @constructor
 */
function QuestionTitle(props) {
    const {
        number,
        title,
        localesTitle,
        direction,
        localesDirection,
        questionMark,
        mark,
        classNameInView,
        viewMode,
        timeSpent,
        penalty,
        isPdf
    } = props;
    const [reviewLater] = useState(false);
    const classes = useStyles(styles)();
    const t = useTranslations();
    const dispatch = useDispatch();
    const { language } = useUserLanguage();
    const selectedQuestion = useSelector((state) => state.selectedQuestion);
    const markButtonActive = selectedQuestion ? selectedQuestion.marked : false;

    function clickToUnSaveQuesFromList(event) {
        event.stopPropagation();
        dispatch(saveQuestion(selectedQuestion.id._id));
    }

    function toggleMarkForReviewFn() {
        dispatch(toggleMarkForReview());
    }

    return (
        <div className={classes.questionText}>
            {(language === 'hn') ?
                <div className="inline-div" style={{marginTop:"45px"}}>
                    {(language === 'hn') && <span className={classes.queTagBold}>{number}</span>}

                    {direction && direction.direction ?
                        <div className={direction && direction.type === 'LONG_TEXT' ? classes.hiddenSm : ''}>
                            <h4>
                                {(language === 'hn') && <MathJax.Context input="tex">
                                    <MathJax.Html html={localesDirection ? localesDirection : direction.direction} />
                                </MathJax.Context>}
                            </h4>
                        </div> : null
                    }
                    <span className="mathjax-line">
                        {(language === 'hn') && <MathJax.Context input="tex">
                            <MathJax.Html html={localesTitle ? localesTitle : title} />
                        </MathJax.Context>}
                    </span>
                </div> : null}
            <div className="englishQuestionText" style={{marginTop:"45px"}}>
                {(language === 'en') &&
                    <span
                        className={classes.queTagBold}>{(!localesTitle) || (localesTitle === title) ? number : ''} </span>}
                {!isPdf && <span className={classes.showAnswerIcon} onClick={clickToUnSaveQuesFromList}><i
                    className={'fa ' + (!selectedQuestion.isSaved ? 'fa-bookmark-o' : 'fa-bookmark')} /></span>}


                {direction && direction.direction ?
                    <div className={classes.hiddenSm}>
                        <h4>
                            {(language === 'en') && <MathJax.Context input="tex">
                                <MathJax.Html html={direction.direction ? direction.direction : localesDirection} />
                            </MathJax.Context>}
                        </h4>
                    </div> : null
                }

                <span className={(!localesTitle) || (localesTitle !== title) ? "mathjax-line" : "mathjax-line-space"}>
                    {direction && direction.type === 'SHORT_TEXT' ?
                        <h4 className="web-hindi-text">
                            {(language === 'en') && <MathJax.Context input="tex">
                                <MathJax.Html html={direction.direction ? direction.direction : localesDirection} />
                            </MathJax.Context>}
                        </h4> : null
                    }
                    {(language === 'en') && <MathJax.Context input="tex">
                        <MathJax.Html html={title ? title : localesTitle} />
                    </MathJax.Context>}
                </span>
            </div>
            <div
                className={classes.questionHeading + ' ' + (direction && direction.type === 'LONG_TEXT' ? classes.questionDirectionHeading : '')}>
                {!viewMode ?
                    <div className={markButtonActive ? classes.markBtn + ' ' + classes.active : classes.markBtn}>
                        <span className={classes.markForReview}><input
                            type="checkbox"
                            className={classes.bullets}
                            value={reviewLater || ''}
                            checked={markButtonActive ? markButtonActive : false}
                            onChange={e => toggleMarkForReviewFn()} name="radio" />
                            <label id="radio">{t('Review Later')}</label>
                        </span>
                    </div> : ''}
                <div className={classes.marksDistribution}>
                    <div className={classes.marksContainer}>
                        {!viewMode ?
                            <React.Fragment>
                                <div className={classes.marksCount}>
                                    <span className={classes.totalMarksContainer}>  + {questionMark} </span>
                                    <span
                                        className={classes.totalMarksContainer + ' ' + classes.deduct}>  - {penalty} </span>
                                </div>
                            </React.Fragment>
                            : !isPdf &&
                            <React.Fragment>
                                <div className={classes.marksCount}>
                                    <span className={classes.totalMarksContainer + ' ' + classNameInView}>{mark} </span>
                                </div>
                                <div className={classes.marksCount}>
                                    <span className={classes.marksBadges}>{timeSpent} </span>
                                </div>
                            </React.Fragment>
                        }

                    </div>
                </div>
            </div>
        </div>
    );
}

const styles = theme => ({
    hiddenSm: {
        display: 'none',
        '@media (max-width: 767px)': {
            display: 'block !important',
        }
    },
    questionText: {
        float: 'left',
        textAlign: 'left',
        width: 'calc(100% - 20px)',
        padding: 10,
        position: 'relative',
        lineHeight: '22px',
        fontWeight: 400,
        color: '#141213',
        marginBottom: 10,
        marginTop: 10,
        '& .MathJax_Display': {
            display: 'contents !important',
        },
        '& .web-hindi-text': {
            fontWeight: 'bold',
        },
        '@media (max-width: 767px)': {
            padding: '10px 0',
            width: '100%',
            overflowWrap: 'break-word'
        }
    },
    queTagBold: {
        padding: '6px 10px',
        borderRadius: 4,
        float:"left",
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#eee',
        fontSize: 16,
        fontWeight: 'bold',
        marginRight: 10,

    },
    englishQuestionText: {
        width: '100%',
        padding: 0,
        float: 'left',
        display:"flex",
        alignItems:"center"
    },
    totalMarksSection: {
        color: '#000',
        display: 'flex',
        flexDirection: 'row',
        position: 'absolute',
        right: 30,
        top: 6,
        marginLeft: 15,
        marginRight: 15,
        borderWidth: 1,
        borderBottomColor: '#eee',
        '@media (min-width:320px) and (max-width:1024px)': {
            marginLeft: 0,
            marginRight: 0,
            position: 'static',
            marginBottom: 10,
            width: '100%',
            marginTop: 20,
        }
    },
    totalMarks: {
        marginBottom: 12,
        marginRight: 20,
        '@media (min-width:320px) and (max-width:1024px)': {
            marginRight: 14,
            marginBottom: 0,
        },
        '@media (min-width:320px) and (max-width:767px)': {
            marginRight: 6,
            marginBottom: 0,
        }
    },
    totalMarksText: {
        color: '#000',
        fontSize: 14,
        fontWeight: 'bold',
        textAlign: 'left',
        marginRight: 10,
        '@media (min-width:320px) and (max-width:767px)': {
            fontSize: 12,
            marginRight: 5,
        }
    },
    totalMarksContainer: {
        padding: '2px 6px',
        color: '#27AE60',
        backgroundColor: '#27AE600F',
        borderRadius: 2,
        fontSize: 13,
        display: 'flex',
        border: '1px solid #27AE60',
        '@media (min-width:320px) and (max-width:1024px)': {
            paddingLeft: 5,
            paddingRight: 5,
        },
        '@media (min-width:320px) and (max-width:767px)': {
            fontSize: 11,
        }
    },
    deduct: {
        backgroundColor: '#c0392b1f',
        marginLeft: 15,
        color: '#c0392b',
        border: '1px solid #c0392b'
    },
    questionHeading: {
        position: 'absolute',
        top: 0,
        right: 32,
        display: 'flex',
        alignItems: 'center',
        '@media (min-width:768px) and (max-width:1100px)': {
            position: 'static',
            marginTop: 10,
        },
        '@media (max-width:767px)': {
            top: -4,
            right: 20,
            height: 40,
            display: 'flex',
            zIndex: 9,
            position: 'absolute',
            alignItems: 'center',
            paddingTop: 0,
            justifyContent: 'flex-end'
        }
    },
    questionDirectionHeading: {
        position: 'static',
        '@media (max-width:767px)': {
            position: 'fixed'
        }
    },
    marksCount: {
        marginRight: 10,
        display: 'flex'
    },
    marksBadges: {
        backgroundColor: '#ffc65820',
        color: '#ffc658',
        border: '1px solid #ffc658',
        borderRadius: 2,
        padding: '2px 6px',
        fontSize: 13,
        textAlign: 'center',
        whiteSpace: 'nowrap',
        marginRight: 0,
        display: 'flex',
    },
    marksContainer: {
        width: '100%',
        display: 'flex',
        alignItems: 'center'
    },
    showAnswerIcon: {
        position: 'absolute',
        top: -3,
        left: -15,
        color: '#9c9c9c',
        cursor: 'pointer',
        fontSize: 24,
        '@media (max-width:767px)': {
            top: 4,
            left: 0,
            fontSize: 24,
            marginLeft: 0,
            position: 'absolute'
        },
        '& .fa-bookmark-o': {
            color: '#008e76'
        },
        '& .fa-bookmark': {
            color: '#008e76'
        }
    },
    markBtn: {
        float: 'none',
        width: 'auto',
        textAlign: 'left',
        backgroundColor: '#fff',
        display: 'inline-block',
        '& span': {
            color: '#888',
        },
        '@media (max-width: 767px)': {
            backgroundColor: 'transparent',
            right: 14,
            position: 'relative'
        }
    },
    active: {
        '& span': {
            color: '#0b2f8a',
        }
    },
    markForReview: {
        width: 'auto',
        display: 'flex',
        padding: 0,
        paddingLeft: 30,
        paddingRight: 30,
        borderRadius: 5,
        textAlign: 'center',
        fontSize: 14,
        marginLeft: 0,
        cursor: 'pointer',
        fontWeight: 600,
        color: '#0039cb',
        '& input': {
            width: 20,
            height: 20,
            position: 'relative',
            margin: 0,
            marginRight: 5,
            top: 1
        },
        '@media (max-width:767px)': {
            paddingLeft: 0,
            padding: 0,
            paddingRight: 0,
            fontSize: 13,

        }
    },
});
export default QuestionTitle;
